export default "/images/4600761cc015e081551813c88ff3b018.avif";